const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const TOKEN_KEY = 'ltbb-ba-token';

const headers = (json = false) => ({
  Authorization: `Bearer ${localStorage.getItem(TOKEN_KEY) || ''}`,
  ...(json ? { 'Content-Type': 'application/json' } : {}),
});

async function request(path, options = {}) {
  const response = await fetch(`${BACKEND_URL}/api/v1/class-packs${path}`, options);
  if (!response.ok) {
    const error = new Error((await response.json().catch(() => null))?.detail || `Class pack request failed: ${response.status}`);
    error.status = response.status;
    throw error;
  }
  return response.json();
}

export const listClassPacks = () => request('', { headers: headers() });
export const getClassPack = (id) => request(`/${encodeURIComponent(id)}`, { headers: headers() });
export const createClassPack = (body) => request('', { method: 'POST', headers: headers(true), body: JSON.stringify(body) });
export const updateClassPack = (id, body) => request(`/${encodeURIComponent(id)}`, { method: 'PUT', headers: headers(true), body: JSON.stringify(body) });
export const archiveClassPack = (id) => request(`/${encodeURIComponent(id)}/archive`, { method: 'POST', headers: headers() });

export async function searchClassLoops(group, options = {}) {
  const { q = '', limit = 100, offset = 0, bpm, bpm_min: bpmMin, bpm_max: bpmMax } = typeof options === 'string' ? { q: options } : options;
  const params = new URLSearchParams({ instrument: group, limit: String(limit), offset: String(offset) });
  if (q) params.set('q', q);
  if (bpm != null) params.set('bpm', String(bpm));
  if (bpmMin != null) params.set('bpm_min', String(bpmMin));
  if (bpmMax != null) params.set('bpm_max', String(bpmMax));
  const response = await fetch(`${BACKEND_URL}/api/v1/loops?${params}`, { headers: headers() });
  if (!response.ok) throw new Error(`Loop search failed: ${response.status}`);
  return response.json();
}
